export class MouldDecisionTool {
  public constructor(
    public webUrl: string,
    public fileName: string,
    public mouldDecisionToolId: string,
    public orderType: string,
    public ugsCode: string,
    public financialRecommendation: string,
    public selectedProposal: string,
    public comment: string,
    public mouldLayout: string,
    public mouldType: string,
    public elements: string,
    public cycletime: string,
    public mouldPrice: string
  ) {}
}
